<template>
  <div id="footer" class="container-fluid">
    <div class="row">
      <div id="footer1" class="col-xs-6 col-sm-12 col-md-3">
        <ul>
          <div class="title1">{{ $t("footer-title.title1") }}</div>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link1") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link2") }}</li>
          <li @click="$router.push('/contactus')">{{ $t("footer-link.link3") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link4") }}</li>
        </ul>

      </div>
      <div id="footer1" class="col-xs-6 col-sm-12 col-md-3">
        <ul>
          <div class="title1">{{ $t("footer-title.title2") }}</div>
          <li @click="$router.push('/PrivacyPolicy')" >{{ $t("footer-link.link5") }}</li>
          <li @click="$router.push('/TermsOfUse')">{{ $t("footer-link.link6") }}</li>
          <li @click="$router.push('/Cookies')">{{ $t("footer-link.link7") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link8") }}</li>
        </ul>
      </div>
      <!-- <div id="footer2" class="col-xs-6 col-sm-12 col-md-3">
<ul>
          <div class="title1">{{ $t("footer-title.title3") }}</div>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link9") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link10") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link11") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link12") }}</li>
        </ul>
      </div> -->
      <div id="footer2" class="col-xs-6 col-sm-12 col-md-3">
<ul>
          <div class="title1">{{ $t("footer-title.title4") }}</div>
          <li @click="Features">{{ $t("footer-link.link13") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link14") }}</li>
          <li @click="$router.push('/Blog')">{{ $t("footer-link.link15") }}</li>
          <li @click="$router.push('/PrivacyPolicy')">{{ $t("footer-link.link16") }}</li>
        </ul>
      </div>
      <div id="footer1" class="col-xs-6 col-sm-12 col-md-3">
        <ul>
          <div class="title1">{{ $t("footer-title.title5") }}</div>
          <li>
            <a
              class="footer-link"
              target="_blank"
              href="https://harrypotterhousequiz.org/"
              :title="$t('footer-link.quiz-title')"
            >{{ $t("footer-link.link17") }}</a>
          </li>
          <li>
            <a
              class="footer-link"
              target="_blank"
              href="https://ai-image.tools/"
              title="ImageTools: bg removal & change backgroud"
            > ImageTools</a>
          </li>
          <li>
            <a
              class="footer-link"
              target="_blank"
              href="https://postergenerator.online/"
              title="Poster Generator: Free Online AI Poster Maker & Generator!"
            >Poster Generator</a>
          </li>
          <li>
            <a
              class="footer-link"
              target="_blank"
              href="https://incredibox-abgerny.online"
              title="Incredibox Abgerny:Interactive Music Creation | Incredibox-Inspired Project"
            >Incredibox Abgerny</a>
          </li>
        </ul>
      </div>
      <p class="copy">Copyright &copy; 2023 - {{ currentYear }} MiniCom Tech Limited</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods:{
    Features(){
       this.$router.push({
          name: "home",
        });
        setTimeout(() => {
          this.scrollToTarget();
        }, 100);
    },
    scrollToTarget() {
      var targetElement = document.getElementById("Features");
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    // goto(path){
    //   this.$router.push("contactus").catch(err =>{console.log(err)})
    // }
  }
};
</script>
<style scoped>
#footer1{
  margin: 80px 0;
}
#footer2{
  margin: 80px 0;
}
#footer1  li {
  padding: 8px;
}
#footer1 .title1{
  font-size: 16px;
  font-weight: 600;
  padding-bottom:18px
}
#footer1  li:hover {
  color: #B6984A;
}
#footer2  li {
  padding: 8px;
}
#footer2 .title1{
  font-size: 16px;
  font-weight: 600;
  padding-bottom:18px
}
#footer2  li:hover {
  color: #B6984A;
}


#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  text-align: center;
  width: 100%;
  padding-bottom: 20px;
}
@media screen and (max-width: 997px) {
  #footer1{
    margin: 50px 0 0px 0;
  }
  #footer2{
    margin: 30px 0 40px 0;
  }
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
  text-align: center;
}
}
.footer-link {
  color: #fff;
  text-decoration: none;
}

.footer-link:hover {
  color: #B6984A;
}

#footer2:last-child {
  margin-top: auto;
  clear: both;
  text-align: left;
}

@media screen and (max-width: 997px) {
  #footer2:last-child {
    margin: 30px 0 40px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue